<template>
    <div v-show="$ability.hasPermission('merchant:ListOwn') && tenantId">
        <div
            v-if="selectedMerchant && selectedMerchant.merchantId"
            class="flex items-center rounded-full border px-2 py-1 transition-colors cursor-pointer"
            :class="
                appliesToCurrentRoute
                    ? 'border-stack-secondary'
                    : 'border-dashed border-theme-border opacity-70'
            "
            :title="
                appliesToCurrentRoute
                    ? 'Esta pantalla usa la tienda seleccionada'
                    : 'Esta pantalla no usa la tienda seleccionada'
            "
            @click="openMerchantModalSelector"
        >
            <span
                v-if="appliesToCurrentRoute"
                class="mr-1.5 h-2 w-2 flex-shrink-0 rounded-full bg-stack-secondary"
                aria-hidden="true"
            ></span>
            <app-button circle icon flat size="large">
                {{ selectedMerchant.merchantType | merchantInfo("icon") }}
            </app-button>
            <div class="ml-1 flex flex-col min-w-0">
                <strong class="leading-1 truncate max-w-35 block">
                    {{ selectedMerchant.name }}
                </strong>
                <small class="truncate">
                    {{ selectedMerchant.address | address | cut(16) }}
                </small>
            </div>
        </div>
        <div v-else>
            <app-button size="small" @click="openMerchantModalSelector">
                No has seleccionado un tienda
            </app-button>
        </div>
        <app-dialog v-model="isOpenModal">
            <template #header>
                <div
                    class="flex justify-center items-center md:flex-row flex-col mt-2"
                >
                    <h4 class="text-center mx-3 text-2xl font-semibold">
                        Selecciona un tienda
                    </h4>
                    <app-button
                        icon
                        circle
                        color="brand-purple"
                        @click="reloadItems(true)"
                    >
                        <reload-icon class="h-5 w-5 text-white" />
                    </app-button>
                </div>
            </template>
            <div>
                <div class="w-full col-mx-10 mx-auto mb-8">
                    <span>
                        Selecciona el tiendaen donde va a registrar sus
                        operaciones (Registro de ventas, inventarios).
                    </span>
                    <span v-if="errorMessage" class="text-danger">
                        {{ errorMessage }}
                    </span>
                    <div
                        v-if="merchantsOwn.length"
                        class="flex flex-col mt-3 justify-center items-center w-full"
                    >
                        <div
                            v-for="item in merchantsOwn"
                            :key="`${item.merchantType}:${item.merchantId}`"
                            class="relative lg:w-8/12 w-full mx-auto"
                        >
                            <button
                                class="flex flex-col md:flex-row justify-between btn btn-stack-primary w-full my-2 text-left py-4"
                                :class="
                                    selectedMerchant.merchantId ===
                                        item.merchantId &&
                                    selectedMerchant.merchantType ===
                                        item.merchantType
                                        ? 'border-4 border-stack-emphasis'
                                        : ''
                                "
                                @click="selectionMerchant(item)"
                            >
                                <div class="flex flex-col">
                                    <h3 class="text-xl">
                                        {{
                                            item.merchantType
                                                | merchantInfo("icon")
                                        }}
                                        {{ item.name }}
                                    </h3>
                                    <p>🗺 {{ item.address }}</p>
                                </div>
                            </button>
                            <button
                                class="absolute bottom-0 right-0 border border-theme-border rounded-full bg-theme-warning p-1"
                                :aria-label="`Ir a tienda${item.name}`"
                                @click="
                                    redirectTo(
                                        `/app/${item.merchantType}s/reduced/${item.merchantId}`
                                    )
                                "
                            >
                                <span> 👀 </span>
                            </button>
                        </div>
                    </div>
                    <div
                        v-else-if="isLoading"
                        class="w-11/12 mx-auto mt-4 text-center"
                    >
                        <span>Cargando tiendas...</span>
                    </div>
                    <div v-else class="w-11/12 mx-auto mt-4">
                        <strong> No tienes tiendas asociadas </strong>
                    </div>

                    <div
                        v-if="tenantId"
                        class="w-11/12 mx-auto mt-6 text-center"
                    >
                        <small class="text-theme-muted">
                            Tenant {{ tenantId }}
                        </small>
                    </div>
                </div>
            </div>
        </app-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import AppDialog from "@/components/utils/AppDialog.vue";

export default {
    name: "MerchantModalSelector",
    components: { AppDialog, ReloadIcon },
    data: () => ({ isOpenModal: false, isLoading: false, errorMessage: "" }),
    computed: {
        ...mapState("commons", [
            "merchantsOwn",
            "selectedMerchant",
            "merchantSelectorRequested"
        ]),
        ...mapState("auth", ["tenantId"]),
        appliesToCurrentRoute() {
            return !!this.$route.meta.usesMerchantContext;
        }
    },
    watch: {
        merchantSelectorRequested(value) {
            if (!value) return;
            this.CLEAR_MERCHANT_SELECTOR_REQUEST();
            this.openMerchantModalSelector();
        }
    },
    async mounted() {
        this.setInput();
    },
    methods: {
        ...mapActions("commons", ["listOwnMerchants"]),
        ...mapActions("auth", ["applyMerchantPermissions"]),
        ...mapMutations("commons", [
            "SET_MERCHANT_SELECTED",
            "CLEAR_MERCHANT_SELECTOR_REQUEST"
        ]),
        async openMerchantModalSelector() {
            this.isOpenModal = true;
            if (this.merchantsOwn.length) return;
            this.isLoading = true;
            try {
                await this.listOwnMerchants({ required: false });
            } catch (error) {
                this.errorMessage = error.message;
            }
            this.isLoading = false;
        },
        async reloadItems() {
            await this.listItems(true);
        },
        async listItems(required = false) {
            this.isLoading = true;
            try {
                await this.listOwnMerchants({
                    required
                });
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.errorMessage = error.message;
                console.error({
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
            if (!required && this.selectedMerchant.merchantId) {
                this.selectionMerchant(this.selectedMerchant);
            }
        },
        setInput() {
            const merchantSelected = this.merchantsOwn.find(
                (item) =>
                    item.merchantId === this.selectedMerchant.merchantId &&
                    item.merchantType === this.selectedMerchant.merchantType
            );
            if (merchantSelected) {
                return;
            }
            if (this.merchantsOwn.length > 0) {
                this.selectionMerchant(this.merchantsOwn[0]);
            }
        },
        selectionMerchant({ merchantId = null, merchantType }) {
            this.isOpenModal = false;
            const selectMerchant = this.merchantsOwn.find(
                (item) =>
                    item.merchantId === merchantId &&
                    item.merchantType === merchantType
            );
            if (!selectMerchant) {
                return;
            }
            this.SET_MERCHANT_SELECTED(selectMerchant);
            this.applyMerchantPermissions(
                selectMerchant.permissions.map((item) => item.slug)
            );
        },
        redirectTo(url) {
            this.isOpenModal = false;
            this.$router.push(url);
        }
    }
};
</script>
